// @copyright  2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'sales_order.page.title': 'Sales Orders',
    'sales_order.page.archive.title': 'Archived Sales Orders',
    'sales_order.page.create.title': 'New Sales Order',
    'sales_order.page.search.title': 'Find Sales Orders',
    'sales_order.page.convert.title': 'Despatch to Invoice',
    'sales_order.page.edit.title': 'Edit Sales Order',
    'sales_order.page.edit.email': 'Email Sales Order',
    // review 20260821T031408Z Issue 11: the viewer's action read the estimate clone's
    // 'invoice.button.email' ("Email Invoice") on a sales order.
    'sales_order.button.email': 'Email Sales Order',

    'sales_order.button.find': 'Find Sales Orders',
    'sales_order.button.cancel': 'Cancel',
    'sales_order.button.create': 'Save',
    'sales_order.button.convert_to_invoice': 'Despatch to Invoice',
    'sales_order.button.new': 'New Sales Order',
    'sales_order.button.void_order': 'Void Sales Order',
    'sales_order.button.cancel_remainder': 'Cancel Remainder',
    // Moving an order between warehouses (2026-08-22). A hold anchors the warehouse, so moving
    // the order moves both where its stock is held and where the goods will be despatched from.
    'sales_order.button.move_warehouse': 'Move to Another Warehouse',
    'sales_order.page.move_warehouse.title': 'Move to Another Warehouse',
    'sales_order.label.current_warehouse': 'Currently held at',
    'sales_order.label.destination_warehouse': 'Move to',
    'sales_order.message.move_warehouse_explainer': 'The order\'s warehouse decides where its stock is held and where the goods will be despatched from. Moving the order releases the hold in one warehouse and takes it in the other.',
    'sales_order.message.move_warehouse_shortfall_title': 'Not all the stock is there',
    'sales_order.message.move_warehouse_shortfall': '{destination} cannot cover the whole reservation — it is short by {shortfall}. If you continue, the order moves and the shortfall is recorded against it. You can also transfer stock into {destination} first and try again.',
    'sales_order.button.move_warehouse_continue': 'Move Anyway',
    'sales_order.button.move_warehouse_cancel': 'Do Not Move',
    'sales_order.message.move_warehouse_done': 'The order was moved to {destination}.',
    'sales_order.message.move_warehouse_done_short': 'The order was moved to {destination}, short by {shortfall}.',
    'sales_order.button.archive': 'Archive',
    'sales_order.button.restore': 'Restore',
    'sales_order.button.reserve': 'Reserve Stock',
    'sales_order.button.release': 'Release Stock',
    'sales_order.button.convert_estimate': 'Convert to Sales Order',
    // design audit 20260821T100139Z Issue 9: previously hardcoded English literals.
    'sales_order.button.add_item': 'Add Item',
    'sales_order.button.remove_item': 'Remove Item',
    'sales_order.label.show_more': 'Show more',
    'sales_order.label.show_less': 'Show less',
    'sales_order.label.more_actions': 'More actions',
    'sales_order.link.view_open': 'View Open Sales Orders',
    'sales_order.link.view_partially_invoiced': 'View Partially Invoiced Sales Orders',
    'sales_order.link.view_closed': 'View Closed Sales Orders',

    'sales_order.placeholder.search': 'Search sales orders',

    'sales_order.message.no_change': 'This sales order has not changed since it was created.',

    'sales_order.link.create_first_sales_order': 'Click here to create your first sales order',
    'sales_order.link.sales_orders': ' Return to Sales Orders',
    'sales_order.link.archive': 'Archived Sales Orders',

    'sales_order.label.cancelled_sales_order': 'Cancelled Sales Order',
    'sales_order.label.void_reason': 'Reason for voiding sales order',
    'sales_order.label.cancel_reason': 'Reason for cancelling the remainder',
    'sales_order.label.sales_order_number': 'Order No',
    'sales_order.label.order_date': 'Order Date',
    'sales_order.label.requested_delivery_date': 'Requested Delivery',
    'sales_order.label.promised_delivery_date': 'Promised Delivery',
    'sales_order.label.currency_name': 'Currency',
    'sales_order.label.draft_sales_order': 'Draft Sales Order',
    'sales_order.label.sales_order': 'Sales Order',
    'sales_order.label.ship_to': 'Ship To',
    'sales_order.label.ship_to_contact_name': 'Ship To Contact',
    'sales_order.label.ship_to_address_line_1': 'Delivery address line 1',
    'sales_order.label.ship_to_address_line_2': 'Delivery address line 2',
    'sales_order.label.ship_to_province': 'Province or parish',
    'sales_order.label.ship_to_postal_code': 'Postal code',
    'sales_order.label.ship_to_country': 'Delivery country',
    'sales_order.label.freight': 'Freight',
    'sales_order.label.status': 'Status',
    'sales_order.label.billing_status': 'Billing',
    'sales_order.label.source_channel': 'Source',
    'sales_order.label.reserve_stock': 'Reserve stock for this order',
    'sales_order.label.reserved_days': 'Reserved (days)',
    'sales_order.label.fulfilling_warehouse': 'Fulfilling warehouse',
    'sales_order.label.assigned_warehouse_hint': 'your assigned warehouse',

    // ER10 — the copy IS the deliverable: with reservation optional, "available" is an upper
    // bound, and the qualified headers plus the banner are the entire mitigation.
    'sales_order.message.reserve_toggle_explainer':
        'Holds these quantities so other sales cannot take them. Stock is still only issued when you despatch. Turn off for drop-ship, forecast orders, or anything you do not want tying up stock.',
    'sales_order.message.unreserved_banner': 'No stock is being held for this order. Another sale can take these items before you invoice them.',
    'sales_order.message.no_warehouse': 'No warehouse recorded',
    'sales_order.message.reserve_shortfall': 'Reserved {reserved} of {requested}. {short} units are not available and have not been held.',

    'sales_order.label.quantity_ordered': 'Ordered',
    'sales_order.label.quantity_invoiced': 'Invoiced',
    'sales_order.label.quantity_cancelled': 'Cancelled',
    'sales_order.label.quantity_outstanding': 'Outstanding',
    'sales_order.label.quantity_reserved': 'Reserved for this order',
    'sales_order.label.units_on_hand': 'On Hand',
    'sales_order.label.units_available': 'Available to others',
    'sales_order.label.despatch_quantity': 'Despatch Now',
    'sales_order.label.linked_invoices': 'Linked Invoices',

    'sales_order.status.draft': 'Draft',
    'sales_order.status.open': 'Open',
    'sales_order.status.closed': 'Closed',
    'sales_order.status.cancelled': 'Cancelled',
    'sales_order.billing_status.not_invoiced': 'Not Invoiced',
    'sales_order.billing_status.partially_invoiced': 'Partially Invoiced',
    'sales_order.billing_status.invoiced': 'Invoiced',
    'sales_order.line_status.open': 'Open',
    'sales_order.line_status.closed': 'Closed',
    'sales_order.line_status.cancelled': 'Cancelled',
    'sales_order.source_channel.direct': 'Direct',
    'sales_order.source_channel.estimate': 'Estimate',

    'sales_order.modal.title.sales_order_void': 'Void Sales Order',
    'sales_order.modal.title.sales_order_cancel': 'Cancel Remainder',
    'sales_order.modal.title.sales_order_archive': 'Archive Sales Order',
    'sales_order.modal.title.sales_order_restore': 'Restore Sales Order',
    'sales_order.modal.title.despatch': 'Despatch to Invoice',
    'sales_order.modal.title.email': 'Email Sales Order',
    'sales_order.modal.message.email': 'Are you sure that you want to email this sales order to {name}?',
    'sales_order.modal.title.reserve': 'Reserve Stock',
    'sales_order.modal.title.release': 'Release Stock',

    'sales_order.modal.message.sales_order_void':
        'Are you sure that you want to void this sales order? Nothing has been invoiced on it, and this action cannot be undone. | Are you sure that you want to void these sales orders? This action cannot be undone.',
    'sales_order.modal.message.sales_order_cancel': 'Are you sure that you want to cancel the outstanding balance of this sales order? What has already been invoiced stays invoiced.',
    'sales_order.modal.message.sales_order_archive': 'Are you sure that you want to move this sales order to the archive? | Are you sure that you want to move these sales orders to the archive?',
    'sales_order.modal.message.sales_order_restore': 'Are you sure that you want to restore this sales order? | Are you sure that you want to restore these sales orders?',
    'sales_order.modal.message.release': 'Are you sure that you want to release the stock held for this order?',

    'sales_order.success.message.sales_order_created': 'Your sales order has been created',
    'sales_order.success.message.sales_order_updated': 'Your sales order has been updated',
    'sales_order.success.message.sales_order_voided': 'Your sales order has been voided',
    'sales_order.success.message.sales_order_cancelled': 'The outstanding balance has been cancelled',
    'sales_order.success.message.sales_order_converted': 'Your sales order was despatched to an invoice.',
    'sales_order.success.message.estimate_converted': 'Your estimate is now a sales order.',
    'sales_order.success.message.stock_reserved': 'Stock has been reserved for this order',
    'sales_order.success.message.stock_reserved_short': 'Stock was reserved, but not in full — the shortfall is shown per line',
    'sales_order.success.message.stock_released': 'The stock held for this order has been released',
    'sales_order.success.message.sales_order_emailed': 'Your sales order has been emailed',
    'sales_order.warning.message.update_shortfall': 'Saved — but the reservation no longer covers this order: {unheld} units are unreserved. Use Reserve now on the order to top it up.',
    'sales_order.success.message.archived_sales_orders': 'Your sales order was moved to the archive | All selected sales orders were moved to the archive',
    'sales_order.success.message.sales_order_restored': 'Your sales order has been restored | All selected sales orders were restored',

    'sales_order.error.message.archived_sales_orders': 'This sales order was already moved to the archive | These sales orders were already moved to the archive',
    'sales_order.error.message.sales_order_restored': 'This sales order was already restored | These sales orders were already restored',
    'sales_order.error.message.error_loading_history': 'There was an error loading the sales order history. Please try again.',

    // Despatch refusals: the 409 names STOCK (the authoritative guard lost a race or the
    // stock is spoken for); the 422 names the ORDER BALANCE (billing more than remains).
    // The two must never be collapsed into one generic message.
    'sales_order.error.message.despatch_insufficient_stock': 'There is not enough stock to despatch this order. Reserved stock held by other orders is listed below.',
    // Strict-binding shape (user ruling 2026-08-21, aligned verbatim with
    // warehouse-transfers-and-assignment wp-34): name the warehouse and point at
    // reassignment, so the operator staring at a full shelf knows what to do next.
    'sales_order.error.message.despatch_warehouse_holds': '{warehouse} holds {available} units. Reduce the quantity or ask a manager to reassign your warehouse.',
    'sales_order.error.message.despatch_over_balance': 'You cannot invoice more than the outstanding quantity on this order.',
    'sales_order.error.message.despatch_nothing_selected': 'Nothing is selected to despatch — set at least one quantity above zero.',
    'sales_order.error.message.despatch_negative_quantity': 'A despatch quantity cannot be negative.',
    'sales_order.error.message.despatch_line_over_outstanding': 'Only {outstanding} outstanding on this line.',
    'sales_order.message.despatch_is_invoice': 'Despatching raises an invoice for these quantities and issues the stock — there is no separate pick list or shipment record.',
    'sales_order.error.message.reservation_disabled': 'Stock reservation is switched off for this organisation.',
};
